module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "ser_1",
      "role": "doc-chapter"
    }
  }, [_c('p', {
    staticClass: "sert"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "ii",
      "id": "pii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Contemporary Approaches to Film and Media Series")]), _vm._v(" "), _c('p', {
    staticClass: "serpf"
  }, [_vm._v("A complete listing of the books in this series can be found online at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.wsupress.wayne.edu",
      "target": "_blank"
    }
  }, [_vm._v("wsupress.wayne.edu")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "serah"
  }, [_vm._v("G"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ENERAL")]), _vm._v(" E"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DITOR")])]), _vm._v(" "), _c('p', {
    staticClass: "sered"
  }, [_vm._v("Barry Keith Grant")]), _vm._v(" "), _c('p', {
    staticClass: "ser1"
  }, [_vm._v("Brock University")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ceac488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-havas-0004.vue
// module id = 63
// module chunks = 0